<template>
    <div class="container">
        <div class="row mt-3">
            <div class="col-4">
                <h4>{{ $t('create') }} {{ $t('user') }}</h4>
                <input type="button" class="btn btn-primary" :value="$t('create') + ' ' + $t('user')"
                    @click="showUserModal = true" />
                <UserModal :show-modal="showUserModal" @close-modal="showUserModal = false" @data-updated="dataUpdated" />
            </div>

            <div class="col-4">
                <h4>{{ $t('edit') }} {{ $t('user_info') }}</h4>
                <input type="button" class="btn btn-primary" :value="$t('edit') + ' ' + $t('user_info')"
                    @click="showEditModal = true" />
                <UserEditModal :show-modal="showEditModal" :data="users"
                    :target="{ name: 'users', label: 'user_name', track_by: 'user_id' }"
                    @close-modal="showEditModal = false" @data-updated="dataUpdated" />
            </div>
            <div class="col-4">
                <h4>{{ $t('delete') }} {{ $t('users') }}</h4>
                <input type="button" class="btn btn-primary" :value="$t('delete') + ' ' + $t('users')"
                    @click="showDeleteModal = true" />
                <DeleteModal :show-modal="showDeleteModal" :data="users"
                    :target="{ name: 'users', label: 'user_name', track_by: 'user_id' }"
                    @close-modal="showDeleteModal = false" @data-updated="dataUpdated" />
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-6">
                <h4>{{ $t('edit_groups_for_users') }}</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="row mt-2">
                    <span>{{ labelText($t('select'), $t('user'), $t('users'), $t('or')) }}</span>
                    <SearchTool :placeholder="$t('search') + ' ' + $t('users') + '...'" :data="users" label="user_name"
                        track-by="user_id" @select="handleUserSelect" />
                </div>
                <div class="row mt-2 w-50">
                    <select id="user-action-select" class="form-select" v-model="selectedOption">
                        <option value="add_selected">{{ $t('add_selected') }} {{ $t('groups_exact') }}</option>
                        <option value="remove_selected">{{ $t('remove_selected') }} {{ $t('groups_exact') }}</option>
                        <option value="remove_all">{{ $t('remove_all') }} {{ $t('groups_exact') }}</option>
                        <option value="copy_all">{{ $t('copy_all') }} {{ $t('groups_exact') }} {{ $t('from_user') }}
                        </option>
                        <option value="move_all">{{ $t('move_all') }} {{ $t('groups_exact') }} {{ $t('from_user') }}
                        </option>
                        
                    </select>
                </div>
                <div class="row mt-2">
                    <div v-if="selectedOption !== 'remove_all'">
                        <SearchTool v-if="selectedOption == 'move_all' || selectedOption == 'copy_all'"
                            :placeholder="$t('search') + ' ' + $t('users') + '...'" :data="users" label="user_name"
                            track-by="user_id" @select="handleSourceSelect" />
                        <SearchTool v-else :placeholder="$t('search') + ' ' + $t('groups') + '...'" :data="groups"
                            label="group_name" track-by="group_id" @select="handleGroupSelect" />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-6">
                        <input type="button" class="btn btn-success" :value="$t('save_changes')" @click="saveChanges" />
                    </div>
                </div>
                <div class="row mt-2">
                    <div v-if="message" :class="alertClass">
                        {{ message }}
                    </div>
                </div>

            </div>
            <div class="col-6">
                <div class="row mt-2" v-if="selectedUsers.length > 0">
                    <div v-for="user in selectedUsers" :key="user.user_id">
                        <UserCard :user="user" :key="i"/>
                    </div>
                </div>
                <div v-else class="row mt-2">
                    <UserCard :user="{}" />
                </div>
            </div>
        </div>
        <div v-if="hasNonAdminUsers" class="row mt-3 w-50">
            <h4>{{ $t('users_no_groups') }}</h4>
            <div v-for="user in usersWithNoGroups" :key="user.user_id">
                <span v-if="user.isadmin == false">{{ user.user_name }}</span>
            </div>
        </div>
    </div>
</template>

<script>
const { getCookie } = require('@/helpers');
import { fetchData } from '@/helpers';
import SearchTool from './SearchTool.vue';
import UserCard from './UserCard.vue';
import UserModal from './UserModal.vue';
import DeleteModal from './DeleteModal.vue';
import UserEditModal from './UserEditModal.vue';
import axios from 'axios';

export default {
    name: 'UserTools',
    components: { SearchTool, UserCard, UserModal, DeleteModal, UserEditModal },
    props: {
        users: {
            type: Array,
            default: () => []
        },
        devices: {
            type: Array,
            default: () => []
        },
        groups: {
            type: Array,
            default: () => []
        }
    },
    emits: ['data-updated'],
    data() {
        return {
            selectedOption: 'add_selected',
            selectedUsers: [],
            selectedSources: [],
            selectedDevices: [],
            selectedGroups: [],
            showUserModal: false,
            showDeleteModal: false,
            showEditModal: false,
            userGroups: [],
            usersWithNoGroups: [],
            message: '',
            alertClass: '',
            i: 0
        }
    },
    computed: {
        hasNonAdminUsers() {
            return this.usersWithNoGroups.some(user => !user.isadmin);
        }
    },
    methods: {
        fetchData,
        dataUpdated() {
            this.$emit('data-updated');
            this.fetchUsersWithNoGroups();
            this.i++; // update the key for the UserCard component
            },
        // async fetchUserGroups() {
        //     this.userGroups = await this.fetchData('usergroups');
        //     this.users.forEach(user => {
        //         user.groups = this.userGroups
        //             .filter(item => item.user_id === user.user_id)
        //             .map(item => ({
        //                 group_id: item.group_id,
        //                 group_name: item.group_name
        //             }));
        //     });
        //     this.i++; // update the key for the UserCard component
        //     //console.log(this.users);     
        // },
        async fetchUsersWithNoGroups() {
            const allData = await this.fetchData('usergroups');
            const userIdsWithGroups = new Set(allData.map(item => item.user_id));
            const usersNoGroups = this.users.filter(user => !userIdsWithGroups.has(user.user_id));
            this.usersWithNoGroups = usersNoGroups;
            //console.log('Users with no groups:', this.usersNoGroups);
        },
        labelText(verb, object1, object2, separator) {
            return `${verb} ${object1} ${separator} ${object2}`;
        },
        setMessage(message, isSuccess) {
            this.message = message;
            this.alertClass = isSuccess ? 'alert alert-success' : 'alert alert-warning';
        },
        handleUserSelect(selectedUsers) {
            this.selectedUsers = selectedUsers;
        },
        handleSourceSelect(selectedSources) {
            this.selectedSources = selectedSources;
        },
        handleDeviceSelect(selectedDevices) {
            this.selectedDevices = selectedDevices;
        },
        handleGroupSelect(selectedGroups) {
            this.selectedGroups = selectedGroups;
        },
        async postData(topic, method, data) {
            this.message = '';
            this.alertClass = '';
            const url = `${this.$url}/${topic}`;
            try {
                const response = await axios({
                    method: method,
                    url: url,
                    headers: {
                        Authorization: 'Bearer ' + getCookie('token'),
                        ContentType: 'application/json'
                    },
                    data: data
                });

                return response;
            } catch (error) {
                console.error('Error posting data to ' + topic + ':', error);

                return error;
            }
        },
        async saveChanges() {
            let action;
            let data = [];
            if (this.selectedOption === 'add_selected') {
                //console.log('Adding selected groups to selected users.');
                action = 'add';
                this.selectedUsers.forEach(user => {
                    this.selectedGroups.forEach(group => {
                        data.push({ user_id: user.user_id, group_id: group.group_id });
                    });
                });
            } else if (this.selectedOption === 'remove_selected') {
                //console.log('Removing selected groups from selected users.');
                action = 'remove';
                this.selectedUsers.forEach(user => {
                    this.selectedGroups.forEach(group => {
                        data.push({ user_id: user.user_id, group_id: group.group_id });
                    });
                });
            } else if (this.selectedOption === 'remove_all') {
                //console.log('Removing all groups from selected users.');
                action = 'remove_all';
                this.selectedUsers.forEach(user => {
                    data.push({ user_id: user.user_id });
                });
            } else if (this.selectedOption === 'copy_all' || this.selectedOption === 'move_all') {
                //console.log('Moving all groups to selected users from selected sources.');
                action = this.selectedOption;
                let sources = [];
                let targets = [];

                // the ones to copy/move to
                this.selectedUsers.forEach(user => {
                    targets.push({ user_id: user.user_id });
                });
                // the ones to copy/move from
                this.selectedSources.forEach(source => {
                    sources.push({ user_id: source.user_id });
                });
                data.push({ sources: sources, targets: targets });
            }

            if (action) {
                const response = await this.postData('usergroups', 'POST', { action, data });
                if (response instanceof Error) {
                    // Handle error response
                    this.setMessage(this.$t('error') + ': ' + response.data, false);
                } else {
                    // Handle successful response
                    this.setMessage(this.$t('success'), true);
                    this.dataUpdated();
                    // Display message for 3 seconds, then erase the message
                    setTimeout(() => {
                        this.setMessage('', true);
                    }, 3000);
                    // refresh data
                }
            }
        }
    },
    async created() {
        //this.fetchUserGroups();
        this.fetchUsersWithNoGroups();
    }
}
</script>

<style scoped>
.custom__tag {
    display: inline-block;
    background: #e4e4e4;
    padding: 5px;
    margin: 2px;
    border-radius: 3px;
}

.custom__remove {
    cursor: pointer;
    margin-left: 5px;
}
</style>